export default async ({ store, router, $paths, $gtm, route, i18n, $WS }) => {
  const fetchingDefaultData = async () => {
    await Promise.allSettled([
      store.dispatch('base/actFetch_appConfig'),
    ])
  }

  if (process.server) {
    await fetchingDefaultData()
    return
  }

  const fetchingUserData = () => {
    $WS?.disconnect?.()
    $WS?.init?.()
    store.dispatch('limits/act_getUserLimits')
    store.dispatch('lobby/fetch_gameFavorites')
    store.dispatch('userMessages/fetch_userMessages')
  }

  const userHandler = async () => {
    await store.dispatch('user/PROFILE_INFO')
    fetchingUserData()
    $gtm.push({ event: 'Route_Auth', pageUrl: route.path, user_id: store.getters['user/user'].id })
  }

  const guestHandler = async () => {
    $WS?.disconnect?.()
    await store.dispatch('user/act_getGuestToken')
    $WS?.init?.()
    $gtm.push({ event: 'Route_Guest', pageUrl: route.path })
  }

  store.commit('user/SET_USER_TOKEN')
  store.commit('user/setLang', i18n.locale)

  store.watch(
    () => store.getters['user/isLoggedIn'],
    () => {
      const user = store.getters['user/user']

      if (!store.getters['user/isLoggedIn']) {
        guestHandler()
        return
      }

      if (user.hasOwnProperty('is_active') && user.is_active !== 1) {
        store.dispatch('user/logout')
        router.push({ path: $paths.home })
        return
      }

      fetchingUserData()
    }
  )

  if (store.getters['user/isLoggedIn']) {
    userHandler()
  }
  else {
    guestHandler()
  }
}
